// extracted by mini-css-extract-plugin
export default {"folderName":"FolderForm_folderName__bv9YL","buttons":"FolderForm_buttons__CQiUw"};